import Vue from "vue";
import Vuex from "vuex";
import Layout from "@/views/index";
import { constantRoutes } from "@/router/index.js";
import { getUserInfo } from "@/api/login";
Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({
  state: {
    token: "",
    userInfo: {},
    sidebarRouters: [],
    rewriteRoutes: [],
    but: {},
    editableTags: [
      {
        title: "首页",
        path: "/Home",
      },
    ],
    editableTagsValue: "/Home",
  },
  mutations: {
    // 登录
    login(state, token) {
      state.token = token;
      localStorage.setItem("token", token);
    },
    // 退出
    logout(state, token) {
      state.token = "";
      localStorage.removeItem("token");
      state.rewriteRoutes = [];
    },
    SET_USERINFO: (state, user) => {
      state.userInfo = user;
      localStorage.setItem("userInfo", JSON.stringify(user));
    },
    SET_ROUTES: (state, routes) => {
      state.rewriteRoutes = routes;
    },
    SET_SIDEBAR_ROUTERS: (state, routes) => {
      state.sidebarRouters = routes;
    },
    // 动态标签
    ADD_TABS: (state, tab) => {
      const bool = state.editableTags.find((item) => {
        if (item.title == "首页") {
          return item.path == tab.path;
        } else {
          return item.path == tab.fullPath;
        }
      });
      if (!bool) {
        state.editableTags.push({
          title: tab.meta.title,
          // path: tab.path,
          path: tab.fullPath,
        });
      }
    },
  },
  actions: {
    // 关闭当前标签
    resetTags({ commit, state }, obj) {
      console.log(obj, "$route", state.editableTags);
      const fullPath = state.editableTags[obj.index].path;
      state.editableTags.splice(obj.index, 1);
      if (state.editableTags.length == 0) return;
      //如果关闭当前页，则激活最后一个标签页
      const path = state.editableTags[state.editableTags.length - 1].path;
      if (fullPath === obj.$route.fullPath && state.editableTags.length != 0) {
        obj.$router.replace({
          path: path == "/" || path == undefined ? "/Home" : path,
        });
      }
    },
    // 获取用户信息
    getUserInfo({ commit, state }) {
      return new Promise((re, rj) => {
        getUserInfo((res) => {
          commit("SET_USERINFO", res.user);
          re(res);
        });
      });
    },
    getRouters({ commit, state }) {
      return new Promise((resolve) => {
        // api.getRouters({}, res => {
        //   const rdata = JSON.parse(JSON.stringify(res.data))
        //   const sdata = JSON.parse(JSON.stringify(res.data))
        //   const sidebarRoutes = filterAsyncRouter(sdata)
        //   const rewriteRoutes = filterAsyncRouter(rdata, false, true)
        //   commit('SET_ROUTES', rewriteRoutes)
        //   commit('SET_SIDEBAR_ROUTERS', constantRoutes.concat(sidebarRoutes))
        //   resolve(rewriteRoutes)
        // let routers = [
        //   {
        //     path: "/system",
        //     name: "产品中心",
        //     hidden: false,
        //     component: Layout,
        //     meta: {
        //       requireAuth: true,
        //       title: "产品中心",
        //       icon: "el-icon-s-data",
        //     },
        //     children: [
        //       {
        //         path: "/system/productCentre",
        //         name: "productCentre",
        //         component: (resolve) =>
        //           require(["@/views/system/productCentre/index"], resolve),
        //         meta: {
        //           requireAuth: true,
        //           title: "产品中心",
        //         },
        //       },
        //       {
        //         path: "/system/productCentre/insureSum",
        //         name: "insureSum",
        //         component: (resolve) =>
        //           require(["@/views/system/productCentre/insure-sum"], resolve),
        //         meta: {
        //           requireAuth: false,
        //           title: "保费试算",
        //         },
        //       },
        //       {
        //         path: "/system/productCentre/insure",
        //         name: "insure",
        //         component: (resolve) =>
        //           require(["@/views/system/productCentre/insure"], resolve),
        //         meta: {
        //           requireAuth: false,
        //           title: "信息填写",
        //         },
        //       },
        //       {
        //         path: "/system/productCentre/pay",
        //         name: "pay",
        //         component: (resolve) =>
        //           require(["@/views/system/productCentre/pay"], resolve),
        //         meta: {
        //           requireAuth: false,
        //           title: "支付方式",
        //         },
        //       },
        //     ],
        //   },
        //   {
        //     path: "/system",
        //     name: "订单中心",
        //     hidden: false,
        //     component: Layout,
        //     meta: {
        //       requireAuth: true,
        //       title: "订单中心",
        //       icon: "el-icon-s-data",
        //     },
        //     children: [
        //       {
        //         path: "/system/orderCentre",
        //         name: "订单中心",
        //         component: (resolve) =>
        //           require(["@/views/system/orderCentre"], resolve),
        //         meta: {
        //           requireAuth: true,
        //           title: "订单中心",
        //         },
        //       },
        //     ],
        //   },
        //   {
        //     path: "/system",
        //     name: "保单中心",
        //     hidden: false,
        //     component: Layout,
        //     meta: {
        //       requireAuth: true,
        //       title: "保单中心",
        //       icon: "el-icon-s-data",
        //     },
        //     children: [
        //       {
        //         path: "/system/policyCentre",
        //         name: "保单中心",
        //         component: (resolve) =>
        //           require(["@/views/system/policyCentre"], resolve),
        //         meta: {
        //           requireAuth: true,
        //           title: "保单中心",
        //         },
        //       },
        //     ],
        //   },
        //   {
        //     path: "/system",
        //     name: "保全中心",
        //     hidden: false,
        //     component: Layout,
        //     meta: {
        //       requireAuth: true,
        //       title: "保全中心",
        //       icon: "el-icon-s-data",
        //     },
        //     children: [
        //       {
        //         path: "/system/allCentre",
        //         name: "保全中心",
        //         component: (resolve) =>
        //           require(["@/views/system/allCentre"], resolve),
        //         meta: {
        //           requireAuth: true,
        //           title: "保全中心",
        //         },
        //       },
        //     ],
        //   },
        //   {
        //     path: "/system",
        //     name: "结算中心",
        //     hidden: false,
        //     component: Layout,
        //     meta: {
        //       requireAuth: true,
        //       title: "结算中心",
        //       icon: "el-icon-s-data",
        //     },
        //     children: [
        //       {
        //         path: "/system/SettlementCentre",
        //         name: "结算中心",
        //         component: (resolve) =>
        //           require(["@/views/system/SettlementCentre"], resolve),
        //         meta: {
        //           requireAuth: true,
        //           title: "结算中心",
        //         },
        //       },
        //     ],
        //   },
        //   {
        //     path: "/system",
        //     name: "续保中心",
        //     hidden: false,
        //     component: Layout,
        //     meta: {
        //       requireAuth: true,
        //       title: "续保中心",
        //       icon: "el-icon-s-data",
        //     },
        //     children: [
        //       {
        //         path: "/system/continueCentre",
        //         name: "续保中心",
        //         component: (resolve) =>
        //           require(["@/views/system/continueCentre"], resolve),
        //         meta: {
        //           requireAuth: true,
        //           title: "续保中心",
        //         },
        //       },
        //     ],
        //   },
        //   {
        //     path: "*",
        //     redirect: "/404",
        //     hidden: true,
        //   },
        // ];
        let routers = [
          {
            path: "*",
            redirect: "/404",
            hidden: true,
          },
        ];
        // const sidebarRoutes = filterAsyncRouter(routers)
        // const rewriteRoutes = filterAsyncRouter(routers, false, true)
        commit("SET_ROUTES", routers);
        console.log(
          "constantRoutes",
          constantRoutes,
          constantRoutes.concat(routers)
        );
        commit("SET_SIDEBAR_ROUTERS", constantRoutes.concat(routers));
        resolve(routers);
        // })
      });
    },
  },
});

// 遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(
  asyncRouterMap = [],
  lastRouter = false,
  type = false
) {
  return asyncRouterMap.filter((route) => {
    if (type && route.children) {
      route.children = filterChildren(route.children);
    }
    if (route.component) {
      // Layout ParentView 组件特殊处理
      if (route.component === "Layout") {
        route.component = Layout;
      } else {
        route.component = (resolve) =>
          require([`@/views${route.path}`], resolve);
      }
    }
    if (route.children != null && route.children && route.children.length > 0) {
      route.children = filterAsyncRouter(route.children, route, type);
    } else {
      // delete route['children']
      // delete route['redirect']
    }
    return true;
  });
}

function filterChildren(childrenMap, lastRouter = false) {
  var children = [];
  childrenMap.forEach((el, index) => {
    children = children.concat(el);
  });
  return children;
}



// WEBPACK FOOTER //
// ./src/vuex/store.js